<div class="no-results inside" *ngIf="diaryForm && (!diaryForm.rules || diaryForm.rules.length === 0)">
  <div class="inner">
    <div class="image">
      <img src="assets/img/no-results-illustration.png" alt="No results found" />
    </div>
    <div class="content">
      <h2>No Rules</h2>
      <p>There are no rules assigned to the e-diary.</p>
    </div>
  </div>
</div>

<ng-container *ngIf="diaryForm && diaryForm.rules && diaryForm.rules.length > 0">
  <div class="rule-panel" *ngFor="let rule of diaryForm.rules; let i = index">
    <div class="rule-panel-head">
      <div class="rule-name-description">
        <div>
          <label>Rule Name</label>
          <span>{{ rule.name}}</span>
        </div>

        <div>
          <label>Rule Description</label>
          <span>{{ rule.description }}</span>
        </div>
      </div>

      <div class="button-container">
        <div>
          <app-button
            text="Remove"
            size="sm"
            type="button"
            margin="none"
            variant="info"
            (clicked)="onRemoveRule(i)"
          />
        </div>

        <div>
          <app-button
            text="Edit"
            size="sm"
            type="button"
            margin="none"
            variant="secondary"
            (clicked)="editRule.emit(rule)"
          />
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-confirm-action-modal #confirmRemoveRule (confirmed)="onConfirmRemoveRule($event)" />

